import React, { useState } from 'react';
import { Form, InputGroup, ListGroup } from 'react-bootstrap';
import { List } from 'react-bootstrap-icons';

import { useSpdCore } from '../../common/hooks/useSpdCore';

interface TextWithDictionarySelectorProps {
  value?: string;
  onChange: (value: string) => void;
  dictionaryType: string;
  readOnly?: boolean;
  rows?: number;
  emptyLabel?: string;
}

export const TextWithDictionarySelector: React.FC<
  TextWithDictionarySelectorProps
> = ({
  value,
  onChange,
  dictionaryType,
  readOnly,
  rows = 3,
  emptyLabel = 'Brak pozycji w słowniku',
}) => {
  const spd = useSpdCore();
  const [showList, setShowList] = useState(false);
  const [options, setOptions] = useState<string[]>([]);
  const [search, setSearch] = useState('');

  const handleOpenList = async () => {
    if (showList) {
      setShowList(false);
      return;
    }
    const items = await spd.dictionaries.getByDictionaryType(dictionaryType);
    setOptions(items.map(item => item.value));
    setSearch('');
    setShowList(true);
  };

  const handleSelect = (option: string) => {
    onChange(option);
    setShowList(false);
    setSearch('');
  };

  const filteredOptions = search
    ? options.filter(o => o.toLowerCase().includes(search.toLowerCase()))
    : options;

  return (
    <div
      style={{ position: 'relative' }}
      role="group"
      onBlur={e => {
        if (!e.currentTarget.contains(e.relatedTarget)) {
          setShowList(false);
        }
      }}
    >
      <InputGroup>
        <Form.Control
          as="textarea"
          rows={rows}
          value={value || ''}
          disabled={readOnly}
          onChange={e => onChange(e.target.value)}
        />
        {!readOnly && (
          <button
            type="button"
            className="btn btn-outline-secondary"
            title="Wybierz z listy"
            onClick={handleOpenList}
          >
            <List />
          </button>
        )}
      </InputGroup>
      {showList && (
        <div className="position-name-selector-dropdown">
          <div className="p-1 border-bottom">
            <Form.Control
              size="sm"
              type="text"
              placeholder="Szukaj..."
              value={search}
              autoFocus
              onChange={e => setSearch(e.target.value)}
            />
          </div>
          <ListGroup variant="flush">
            {filteredOptions.length === 0 && (
              <ListGroup.Item className="text-muted">
                {emptyLabel}
              </ListGroup.Item>
            )}
            {filteredOptions.map(opt => (
              <ListGroup.Item
                key={opt}
                action
                onMouseDown={e => e.preventDefault()}
                onClick={() => handleSelect(opt)}
              >
                {opt}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      )}
    </div>
  );
};
